// extracted by mini-css-extract-plugin
export default {"vid":"video__vid__EXpxn"};